import React from 'react';
import { Control, FieldValues, Path } from 'react-hook-form';

import { AllocationType } from '@ndvr/portfolio-api';

import { FormControl, FormDescription, FormField, FormItem, FormLabel } from '@/components/ui/form';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

interface AllocationTypeSelectorProps<T extends FieldValues> {
    control: Control<T>;
    name: Path<T>;
    disabled: boolean;
    disabledReason?: string;
}

export function AllocationTypeSelector<T extends FieldValues>({
    control,
    name,
    disabled,
    disabledReason,
}: AllocationTypeSelectorProps<T>) {
    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem>
                    <FormLabel>Allocation Type</FormLabel>
                    {disabled && disabledReason && <FormDescription>{disabledReason}</FormDescription>}
                    <FormControl>
                        <RadioGroup
                            value={field.value}
                            onValueChange={field.onChange}
                            className="mt-1 flex gap-4"
                            disabled={disabled}
                        >
                            <div className="flex items-center space-x-2">
                                <RadioGroupItem value={AllocationType.PERSONAL} id="personal" disabled={disabled} />
                                <label
                                    htmlFor="personal"
                                    className={`text-sm font-medium ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
                                >
                                    Personal
                                </label>
                            </div>
                            <div className="flex items-center space-x-2">
                                <RadioGroupItem value={AllocationType.SHARED} id="shared" disabled={disabled} />
                                <label
                                    htmlFor="shared"
                                    className={`text-sm font-medium ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
                                >
                                    Shared
                                </label>
                            </div>
                        </RadioGroup>
                    </FormControl>
                </FormItem>
            )}
        />
    );
}
